import React from "react";
import exampleImageEn from "../../assets/example/graf-en.png";
import exampleImageMobileEn from "../../assets/example/graf-en.png";
import exampleImagePl from "../../assets/example/graf-pl.svg";
import exampleImageMobilePl from "../../assets/example/graf-mobile-pl.png";
import Animate from "../Animate";

const Example = ({  language }) => (
  <div id="example" className="landing-container-examples">
    <div className="landing-layout">
      <div className="landing-example-image">
        <Animate type="zoom-in">
          <img
            style={{ backgroundColor: "transparent" }}
            className="landing-example-image-desktop"
            src={language === "pl" ? exampleImagePl : exampleImageEn}
            alt="example aplication"
          />
          <img
            className="landing-example-image-mobile"
            src={language === "pl" ? exampleImageMobilePl : exampleImageMobileEn}
            alt=""
          />
        </Animate>
      </div>
    </div>
  </div>
);

export default Example;
